import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "withHoverBg", "size", "variant", "fixedWidth", "as"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import Default from 'react-bootstrap/Anchor';
import { jsx as _jsx } from "react/jsx-runtime";
export var LinkBase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      withHoverBg = _ref.withHoverBg,
      size = _ref.size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      fixedWidth = _ref.fixedWidth,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'a' : _ref$as,
      rest = _objectWithoutProperties(_ref, _excluded);

  var sizeValue = size === 'md' ? undefined : size;
  return /*#__PURE__*/_jsx(Default, _objectSpread(_objectSpread({
    ref: ref,
    className: classNames('link', (_classNames = {
      'link-with-hover-bg': withHoverBg,
      'link-fixed-width': fixedWidth
    }, _defineProperty(_classNames, "link-".concat(sizeValue), sizeValue), _defineProperty(_classNames, "link-".concat(variant), variant), _classNames), className)
  }, rest), {}, {
    children: children
  }));
});